import { useState } from 'react'

import { Wrapper, VideoName, StyledBase64Image, ImageWrapper } from './Styled'
import { useHasPayment } from 'hooks/useHasPayment'
import { usePaymentTypeImage } from 'component/PaymentTypeImages/hooks/usePaymentTypeImage'
import { useNavigateTo } from 'hooks/useNavigateTo'
import { videoPaymentType } from 'constant/video'
import useNavigateToShortVideo from 'hooks/useNavigateToShortVideo'

interface NormalVideoInfo {
  videoInfo: any
  columns?: number
  width?: string
  shortInfo?: undefined
  overflow?: any
  noTitle?: boolean
  textAlign?: string
  allowUnload?: boolean
  noLazy?: boolean
  fontSize?: string | number
  [key: string]: any
}

interface ShortVideoInfo {
  videoInfo: any
  columns?: number
  width?: string
  shortInfo: { list: object[] }
  overflow?: any
  noTitle?: boolean
  textAlign?: string
  allowUnload?: boolean
  noLazy?: boolean
  fontSize?: string | number
  [key: string]: any
}

type Props = NormalVideoInfo | ShortVideoInfo

/**
 * 元件 - 影片 Item
 */
export default function VideoBoxVertical({
  videoInfo,
  width,
  columns = 2,
  shortInfo,
  overflow,
  noTitle,
  textAlign = 'left',
  allowUnload = false,
  noLazy,
  fontSize,
  ...props
}: Props) {
  const hasPayment = useHasPayment()
  const isVideo = shortInfo == null
  const { navigateToViewVideo } = useNavigateTo()
  const { navigateToViewShortWithPartVideoCheck } = useNavigateToShortVideo()

  const { title, coverphoto_v } = videoInfo

  const imageJSX = usePaymentTypeImage(videoInfo)

  const [base64Img, setBase64Img] = useState<string | undefined>()

  const onVideoBoxClick = () => {
    if (shortInfo == null) {
      navigateToViewVideo({
        ...videoInfo,
        posterImg: `data:image/jpeg;base64, ${base64Img}`,
      })
    } else {
      navigateToViewShortWithPartVideoCheck({
        videoList: shortInfo.list,
        videoInfo,
        posterImg: `data:image/jpeg;base64, ${base64Img}`,
      })
    }
  }

  const showPayment = isVideo ? hasPayment : hasPayment && videoInfo.payment_type !== videoPaymentType.FREE

  return (
    <Wrapper {...props} onClick={onVideoBoxClick} width={width} columns={columns}>
      <ImageWrapper>
        <StyledBase64Image
          overflow={overflow}
          aspectRatio={1 / 1.414}
          src={coverphoto_v}
          onBase64ImageLoad={setBase64Img}
          noLazy={noLazy}
          allowUnload={allowUnload}
        />
        {showPayment && imageJSX}
      </ImageWrapper>

      {!noTitle && (
        <VideoName textAlign={textAlign} fontSize={fontSize}>
          {title}
        </VideoName>
      )}
    </Wrapper>
  )
}
